import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=347b93c8&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=347b93c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347b93c8",
  null
  
)

export default component.exports